import EFOcats_event_core from './efocats_event_core.js';

/**
 * .dateSetting inputを選択イベント
 */
export default class EFOcats_event_date extends EFOcats_event_core {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    if (this.$('.dateSetting input')) {
      /*
            var $ = require('jquery');
            require('jquery-ui/ui/widgets/datepicker');
            require('jquery-ui/ui/i18n/datepicker-ja');

            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', 'https://formcats.com/common/css/jquery-ui.css');
            head.appendChild(link);


            var style = '<link rel="stylesheet" href="https://formcats.com/common/css/jquery-ui.css">';
            this.$('head link:last').after(style);

            var script = '<script src="https://formcats.com/common/js/jquery-1.12.4.min.js" charset="utf-8"></script>';
            this.$('head link:last').after(script);

            var script1Timer = setInterval( () => {
                if (typeof jQuery === "function") {
                    clearInterval(script1Timer);
                    var script2 = '<script src="https://formcats.com/common/js/jquery-ui.min.js" charset="utf-8"></script>';
                    this.$('head script:last').after(script2);

                    var script2Timer = setInterval( () =>{
                        if (typeof jQuery(".dateSetting input").datepicker === "function") {
                            clearInterval(script2Timer);

                            //カレンダーUiの起動
                            jQuery(".dateSetting input").datepicker({
                                monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
                                monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
                                dateFormat: "yy-mm-dd",
                                dayNames: ["日", "月", "火", "水", "木", "金", "土"],
                                dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
                                dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
                                showMonthAfterYear: true,
                                yearSuffix: "年",
                            });


                        }
                    }, 100);

                }
            }, 100);

            */
    }
  }
}
